import { render, staticRenderFns } from "./NxmbStudent.vue?vue&type=template&id=5b19e276&scoped=true&"
import script from "./NxmbStudent.vue?vue&type=script&lang=js&"
export * from "./NxmbStudent.vue?vue&type=script&lang=js&"
import style0 from "./NxmbStudent.vue?vue&type=style&index=0&id=5b19e276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19e276",
  null
  
)

export default component.exports